import { render, staticRenderFns } from "./landing.vue?vue&type=template&id=f4220b5c&scoped=true&"
import script from "./landing.vue?vue&type=script&lang=js&"
export * from "./landing.vue?vue&type=script&lang=js&"
import style0 from "./landing.vue?vue&type=style&index=0&id=f4220b5c&lang=scss&scoped=true&"
import style1 from "./landing.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4220b5c",
  null
  
)

export default component.exports